// extracted by mini-css-extract-plugin
module.exports = {"container":"CRiVGo45o8rp6PRUGmiX8"};